module.exports = new __parcel__URL__("apple.ee886279.svg").toString();